var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "theme-ui/jsx-runtime";
import React from "react";
import { Box, Input as ThemeInput, Label as ThemeLabel } from "theme-ui";
import { FormVariants, FontWeight } from "../../index";
import { randomId } from "../../utils";
import { FormError } from "./Error";
export const absolute = {
    position: "absolute"
};
export const relative = {
    position: "relative"
};
export const labelStyle = Object.assign(Object.assign({}, absolute), { top: 12, left: 10, paddingTop: "0.15rem", transition: "all 0.1s ease-in", cursor: "text" });
export const focusedLabelStyle = {
    top: "0.4375rem",
    left: 10,
    paddingLeft: "0.0625rem",
    variant: "text.label3",
    fontWeight: FontWeight.textBold
};
export const Input = React.forwardRef((_a, ref) => {
    var { id, placeholder, name, value, type, children, required, hasError, errorMessage } = _a, props = __rest(_a, ["id", "placeholder", "name", "value", "type", "children", "required", "hasError", "errorMessage"]);
    if (!id) {
        id = randomId();
    }
    const focusSelectors = {
        "& label": focusedLabelStyle
    };
    const boxStyle = Object.assign(Object.assign({ marginBottom: 0, input: {
            paddingTop: 12
        } }, relative), focusSelectors);
    return (_jsxs(Box, { sx: boxStyle, className: "form-input", children: [_jsx(ThemeLabel, { sx: Object.assign({ variant: `forms.${FormVariants.label}` }, labelStyle), htmlFor: id, children: children }), _jsx(ThemeInput, Object.assign({ ref: ref, sx: { variant: `forms.${FormVariants.input}` }, placeholder: placeholder || "", name: name, value: value, id: id, type: type }, props)), hasError && errorMessage && _jsx(FormError, { children: errorMessage })] }));
});
export const TextInput = React.forwardRef((props, ref) => _jsx(Input, Object.assign({ type: "text" }, props, { ref: ref })));
export const EmailInput = React.forwardRef((props, ref) => _jsx(Input, Object.assign({ type: "email" }, props, { ref: ref })));
export const PhoneInput = React.forwardRef((props, ref) => _jsx(Input, Object.assign({ type: "tel" }, props, { ref: ref })));
export const PasswordInput = React.forwardRef((props, ref) => _jsx(Input, Object.assign({ type: "password" }, props, { ref: ref })));
//# sourceMappingURL=Input.js.map